import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/ic-kontrol';

const BILESEN_BILGI: Record<string, { ikon: string; renk: string; aciklama: string }> = {
  KO: { ikon: '🏛️', renk: '#1a56db', aciklama: 'Standart 1-4 • Etik Değerler, Misyon, Personel Yeterliliği, Yetki Devri' },
  RY: { ikon: '⚠️', renk: '#d03801', aciklama: 'Standart 5-6 • Planlama ve Programlama, Risklerin Belirlenmesi' },
  KF: { ikon: '✅', renk: '#057a55', aciklama: 'Standart 7-12 • Kontrol Stratejileri, Prosedürler, Görevler Ayrılığı, Hiyerarşik Kontrol, Süreklilik, BT' },
  BI: { ikon: '📡', renk: '#7e3af2', aciklama: 'Standart 13-16 • Bilgi ve İletişim, Raporlama, Kayıt/Dosyalama, Bildirim' },
  IZ: { ikon: '🔍', renk: '#b45309', aciklama: 'Standart 17-18 • İç Kontrolün Değerlendirilmesi, İç Denetim' },
};

const UYUM_SECENEKLER = [
  { value: 'tam_uyumlu',            label: 'Tam Uyumlu',            bg: '#d1fae5', text: '#065f46' },
  { value: 'kismi_uyumlu',          label: 'Kısmen Uyumlu',         bg: '#fef3c7', text: '#92400e' },
  { value: 'uyumsuz',               label: 'Uyumsuz',               bg: '#fee2e2', text: '#991b1b' },
  { value: 'degerlendirme_bekliyor',label: 'Değerlendirme Bekliyor',bg: '#f3f4f6', text: '#6b7280' },
];

export default function IcKontrolStandartlar() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const [tum, setTum] = useState<any[]>([]);
  const [ozet, setOzet] = useState<any>({});
  const [filtreBilesen, setFiltreBilesen] = useState('');
  const [filtreUyum, setFiltreUyum] = useState('');
  const [yil, setYil] = useState(new Date().getFullYear());
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState({ uyum_durumu: '', uyum_aciklamasi: '', kanit_belgeler: '', eksiklikler: '', onlemler: '' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [grupGoster, setGrupGoster] = useState<Set<string>>(new Set(['KO', 'RY', 'KF', 'BI', 'IZ']));

  const yukle = () => {
    const qs = new URLSearchParams({ yil: String(yil), ...(filtreBilesen ? { bilesen_kodu: filtreBilesen } : {}), ...(filtreUyum ? { uyum_durumu: filtreUyum } : {}) }).toString();
    fetch(`${API}/standartlar?${qs}`, { headers }).then(r => r.json()).then(d => setTum(Array.isArray(d) ? d : []));
    fetch(`${API}/standartlar/ozet?yil=${yil}`, { headers }).then(r => r.json()).then(d => setOzet(d || {}));
  };

  useEffect(() => { yukle(); }, [filtreBilesen, filtreUyum, yil]);

  const kaydet = async () => {
    if (!secili) return;
    setKaydediliyor(true);
    await fetch(`${API}/standartlar/${secili.id}`, { method: 'PUT', headers, body: JSON.stringify(form) });
    setSecili(null);
    yukle();
    setKaydediliyor(false);
  };

  const toggleGrup = (kod: string) => {
    setGrupGoster(prev => {
      const s = new Set(prev);
      s.has(kod) ? s.delete(kod) : s.add(kod);
      return s;
    });
  };

  const uyumBadge = (durum: string) => {
    const s = UYUM_SECENEKLER.find(o => o.value === durum) || UYUM_SECENEKLER[3];
    return <span style={{ background: s.bg, color: s.text, padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>{s.label}</span>;
  };

  // Standartları bileşen > standart numarası gruplandır
  const bilesenler = ['KO', 'RY', 'KF', 'BI', 'IZ'];
  const gruplu: Record<string, Record<number, any[]>> = {};
  for (const b of bilesenler) {
    gruplu[b] = {};
    tum.filter(s => s.bilesen_kodu === b).forEach(s => {
      if (!gruplu[b][s.standart_no]) gruplu[b][s.standart_no] = [];
      gruplu[b][s.standart_no].push(s);
    });
  }

  const toplamUyum = (bilesen: string) => {
    const b = ozet[bilesen] || {};
    return { tam: b.tam || 0, toplam: b.toplam || 0, oran: b.uyum_orani || 0 };
  };

  return (
    <div style={{ padding: '24px', maxWidth: 1200 }}>
      {/* Başlık */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: '#111827' }}>📋 Standart Uyum Değerlendirmesi</h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
          Kamu İç Kontrol Standartları Tebliği • 18 Standart • 79 Genel Şart
        </p>
      </div>

      {/* Yıl Seçimi */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 20, flexWrap: 'wrap' }}>
        <input type="number" value={yil} onChange={e => setYil(Number(e.target.value))}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, fontWeight: 600, width: 100 }} />
        <select value={filtreBilesen} onChange={e => setFiltreBilesen(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Bileşenler</option>
          {bilesenler.map(b => <option key={b} value={b}>{BILESEN_BILGI[b]?.ikon} {b}</option>)}
        </select>
        <select value={filtreUyum} onChange={e => setFiltreUyum(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Durumlar</option>
          {UYUM_SECENEKLER.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <div style={{ marginLeft: 'auto', fontSize: 13, color: '#6b7280' }}>
          Toplam: <strong>{tum.length}</strong> şart
        </div>
      </div>

      {/* Bileşen Özet Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 12, marginBottom: 24 }}>
        {bilesenler.map(b => {
          const info = BILESEN_BILGI[b];
          const { tam, toplam, oran } = toplamUyum(b);
          return (
            <div key={b} onClick={() => setFiltreBilesen(filtreBilesen === b ? '' : b)} style={{
              background: '#fff', border: `2px solid ${filtreBilesen === b ? info.renk : '#e5e7eb'}`,
              borderRadius: 10, padding: '14px 12px', cursor: 'pointer', transition: 'all 0.15s'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <span style={{ fontSize: 24 }}>{info.ikon}</span>
                <span style={{ fontWeight: 800, fontSize: 18, color: oran >= 75 ? '#065f46' : oran >= 50 ? '#92400e' : '#991b1b' }}>%{oran}</span>
              </div>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#111827', marginTop: 6 }}>{b}</div>
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{tam}/{toplam} şart uyumlu</div>
              <div style={{ marginTop: 8, height: 4, background: '#e5e7eb', borderRadius: 2 }}>
                <div style={{ height: '100%', width: `${oran}%`, background: oran >= 75 ? '#10b981' : oran >= 50 ? '#f59e0b' : '#ef4444', borderRadius: 2 }} />
              </div>
            </div>
          );
        })}
      </div>

      {/* Bileşen Grupları */}
      {bilesenler
        .filter(b => !filtreBilesen || b === filtreBilesen)
        .map(b => {
          const info = BILESEN_BILGI[b];
          const standartlar = gruplu[b];
          const acik = grupGoster.has(b);
          if (Object.keys(standartlar).length === 0) return null;
          return (
            <div key={b} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, marginBottom: 16, overflow: 'hidden' }}>
              {/* Bileşen Başlığı */}
              <div onClick={() => toggleGrup(b)} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px',
                background: '#f9fafb', cursor: 'pointer', borderBottom: acik ? '1px solid #e5e7eb' : 'none'
              }}>
                <span style={{ fontSize: 22 }}>{info.ikon}</span>
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>{b} — {
                    b === 'KO' ? 'Kontrol Ortamı' : b === 'RY' ? 'Risk Yönetimi' : b === 'KF' ? 'Kontrol Faaliyetleri' : b === 'BI' ? 'Bilgi ve İletişim' : 'İzleme'
                  }</span>
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{info.aciklama}</div>
                </div>
                <span style={{ color: '#9ca3af', fontSize: 18 }}>{acik ? '▲' : '▼'}</span>
              </div>

              {acik && Object.entries(standartlar).sort(([a], [b]) => Number(a) - Number(b)).map(([sno, sartlar]) => (
                <div key={sno} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <div style={{ padding: '10px 20px', background: '#fafafa', fontSize: 13, fontWeight: 700, color: '#374151', borderBottom: '1px solid #f3f4f6' }}>
                    Standart {sno}: {(sartlar[0] as any).standart_adi}
                  </div>
                  {sartlar.map((sart: any) => (
                    <div key={sart.id} style={{
                      display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 20px',
                      borderBottom: '1px solid #f9fafb', cursor: 'pointer', transition: 'background 0.1s'
                    }}
                      onClick={() => { setSecili(sart); setForm({ uyum_durumu: sart.uyum_durumu, uyum_aciklamasi: sart.uyum_aciklamasi || '', kanit_belgeler: sart.kanit_belgeler || '', eksiklikler: sart.eksiklikler || '', onlemler: sart.onlemler || '' }); }}
                      onMouseEnter={e => (e.currentTarget.style.background = '#f9fafb')}
                      onMouseLeave={e => (e.currentTarget.style.background = '')}
                    >
                      <div style={{ minWidth: 40, color: '#9ca3af', fontSize: 12, fontFamily: 'monospace', paddingTop: 2 }}>{sart.sart_no}</div>
                      <div style={{ flex: 1, fontSize: 13, color: '#374151', lineHeight: '1.5' }}>{sart.sart_metni}</div>
                      <div style={{ minWidth: 120, textAlign: 'right' }}>{uyumBadge(sart.uyum_durumu)}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          );
        })}

      {/* Değerlendirme Modal */}
      {secili && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>✏️ Şart Değerlendirmesi — {secili.sart_no}</h2>
              <button onClick={() => setSecili(null)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            <div style={{ background: '#f9fafb', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#374151', lineHeight: 1.6 }}>
              {secili.sart_metni}
            </div>

            <div style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Uyum Durumu *</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 8 }}>
                  {UYUM_SECENEKLER.map(o => (
                    <label key={o.value} style={{
                      display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderRadius: 8, cursor: 'pointer',
                      border: `2px solid ${form.uyum_durumu === o.value ? '#3b82f6' : '#e5e7eb'}`,
                      background: form.uyum_durumu === o.value ? '#eff6ff' : '#fff'
                    }}>
                      <input type="radio" name="uyum" value={o.value} checked={form.uyum_durumu === o.value}
                        onChange={() => setForm(f => ({ ...f, uyum_durumu: o.value }))} style={{ accentColor: '#3b82f6' }} />
                      <span style={{ background: o.bg, color: o.text, padding: '1px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600 }}>{o.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Uyum Açıklaması</label>
                <textarea value={form.uyum_aciklamasi} onChange={e => setForm(f => ({ ...f, uyum_aciklamasi: e.target.value }))}
                  rows={3} placeholder="Bu şart için yapılan çalışmalar, uygulama durumu..."
                  style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Kanıt Belgeler</label>
                <textarea value={form.kanit_belgeler} onChange={e => setForm(f => ({ ...f, kanit_belgeler: e.target.value }))}
                  rows={2} placeholder="Uyumu kanıtlayan belge, prosedür, yönerge adları..."
                  style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
              </div>

              {['kismi_uyumlu', 'uyumsuz'].includes(form.uyum_durumu) && (
                <>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Eksiklikler</label>
                    <textarea value={form.eksiklikler} onChange={e => setForm(f => ({ ...f, eksiklikler: e.target.value }))}
                      rows={2} placeholder="Mevcut eksiklik ve uyumsuzluklar..."
                      style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Alınacak Önlemler</label>
                    <textarea value={form.onlemler} onChange={e => setForm(f => ({ ...f, onlemler: e.target.value }))}
                      rows={2} placeholder="Uyumsuzluğu gidermek için planlanacak eylemler..."
                      style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
                  </div>
                </>
              )}
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end' }}>
              <button onClick={() => setSecili(null)} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 14 }}>İptal</button>
              <button onClick={kaydet} disabled={kaydediliyor || !form.uyum_durumu} style={{
                padding: '10px 24px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                background: !form.uyum_durumu ? '#9ca3af' : '#1d4ed8', color: '#fff'
              }}>{kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
